const API_BASE_URL = (import.meta.env.VITE_API_URL || '').replace(/\/+$/, '');

function getErrorMessage(data) {
  if (data && typeof data === 'object' && typeof data.message === 'string') {
    return data.message;
  }
  return 'Mesaj gonderilirken beklenmeyen bir hata olustu.';
}

export async function submitContactForm(payload) {
  const response = await fetch(`${API_BASE_URL}/api/public/contact-submissions`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    let errorData = null;
    try {
      errorData = await response.json();
    } catch {
      errorData = null;
    }
    throw new Error(getErrorMessage(errorData));
  }

  return response.json();
}
